module.exports = __webpack_public_path__ + "static/btn_04.1334dc04.png";